import styled from 'styled-components'

// Sections
export const TopSection = styled.div`
  height: 16vh;
  width: 100%;
`
export const TopBarContainer = styled.div`
  height: 9vh;
  background-color: #fff;
  box-shadow: 0px 1px 5px rgba(0, 0, 0, 0.15);
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 65px;
`

export const SubNav = styled.div`
  width: 100%;
  height: 7vh;
  padding: 28px 41px;
  display: flex;
  justify-content: flex-end;
`

export const MainContainer = styled.div<{ offset: number }>`
  height: ${(props) => 100 - props.offset}vh;
  display: flex;
`

export const BottomBarContainer = styled.div<{ hiddenEdit?: boolean }>`
  height 14vh;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const ContentContainer = styled.div<{ fullWidth?: boolean }>`
  width: ${(props) => (props.fullWidth ? '100%' : '78%')};
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  @media (max-width: 1200px) {
    width: 100%;
  }
`

export const LogoContainer = styled.div`
  background-color: var(--primary);
  height: 100%;
  width: 22%;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 1200px) {
    display: none;
  }
`

export const TopBarContentContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 1rem;
  width: 78%;

  @media (min-width: 633px) {
    padding-left: 98px;
    padding-right: 41px;
  }
`
